import { render, staticRenderFns } from "./holidayActMaleRules.vue?vue&type=template&id=31210333&scoped=true"
import script from "./holidayActMaleRules.vue?vue&type=script&lang=js"
export * from "./holidayActMaleRules.vue?vue&type=script&lang=js"
import style0 from "./holidayActMaleRules.vue?vue&type=style&index=0&id=31210333&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31210333",
  null
  
)

export default component.exports